import { store } from '@/redux/store/store';

import Constants from './constants';

let dbPermissions;
let merchantType;

function setPermission(per) {
	dbPermissions = per;
}

function setMerchantType(type) {
	merchantType = type;
}

function checkP2PPermission(type) {
	if (merchantType === undefined) {
		const storeCopy = store.getState();
		const profile = storeCopy.merchantDetails
			? storeCopy.merchantDetails.profile
			: undefined;
		merchantType = profile ? profile.type : undefined;
	}

	if (merchantType === Constants.P2P_MERCHANT)
		return Constants.P2P_PERMISSIONS[type];

	return true;
}

function typeHasPermission(type) {
	if (dbPermissions) return dbPermissions[type] && dbPermissions[type].active;
	const storeCopy = store.getState();
	if (storeCopy.userAuth && storeCopy.userAuth.user) {
		const { permissions } = storeCopy.userAuth.user;
		dbPermissions =
			permissions && permissions.data ? permissions.data : undefined;
		return dbPermissions
			? dbPermissions[type] && dbPermissions[type].active
			: false;
	}
	return false;
}

function checkCurrentMerchantPermissions(type) {
	return checkP2PPermission(type) && typeHasPermission(type);
}

function checkPermissionsViewVisibility(component, type) {
	if (checkCurrentMerchantPermissions(type)) return component;
	return undefined;
}

function formatPermission(data) {
	const permsissonObject = {};
	if (data.length > 0) {
		for (let i = 0; data.length > i; i += 1) {
			permsissonObject[data[i].permission] = data[i];
		}
	}
	return permsissonObject;
}

export {
	checkPermissionsViewVisibility,
	checkCurrentMerchantPermissions,
	typeHasPermission,
	setPermission,
	setMerchantType,
	formatPermission,
};
